import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!process.env.REACT_APP_BACKEND_URL) {
  root.render(
    <div data-testid="config-error" style={{ fontFamily: "sans-serif", padding: 32 }}>
      <h1 style={{ fontSize: 20 }}>Configuration error</h1>
      <p>REACT_APP_BACKEND_URL is not set. The frontend cannot reach the API without it (see DEPLOYMENT.md).</p>
    </div>,
  );
} else {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
